import React, { useEffect, useRef, useState } from 'react';
import api from '../../services/api';

/** Champ Zone avec suggestions (régions, départements, communes) — lot DI § 3. */
export const ZoneAutocomplete = ({ zoneType, zone, libelle, onChoisir, onEffacer }) => {
  const [saisie, setSaisie] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [ouvert, setOuvert] = useState(false);
  const boite = useRef(null);

  useEffect(() => {
    const dehors = (e) => { if (boite.current && !boite.current.contains(e.target)) setOuvert(false); };
    document.addEventListener('mousedown', dehors);
    return () => document.removeEventListener('mousedown', dehors);
  }, []);

  useEffect(() => {
    if (saisie.trim().length < 2) { setSuggestions([]); return; }
    const minuteur = setTimeout(async () => {
      try {
        const { data } = await api.get('/observatoire/zones', { params: { q: saisie.trim() } });
        setSuggestions(data.zones || []);
        setOuvert(true);
      } catch (_) { setSuggestions([]); }
    }, 250);
    return () => clearTimeout(minuteur);
  }, [saisie]);

  const TYPES = { region: 'Région', departement: 'Département', commune: 'Commune' };

  return (
    <div className="relative min-w-0" ref={boite}>
      <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1">
        Zone
      </label>
      {zoneType ? (
        <div
          className="h-11 px-3 rounded-lg border border-slate-300 bg-white flex items-center gap-2"
          data-testid="observatoire-zone-active"
        >
          <i className="bi bi-geo-alt text-slate-400"></i>
          <span className="text-sm text-slate-800 truncate flex-1">{libelle}</span>
          <button
            type="button"
            onClick={() => { setSaisie(''); onEffacer(); }}
            data-testid="observatoire-zone-clear"
            aria-label="Revenir à la France entière"
            className="w-8 h-8 shrink-0 rounded-md text-slate-400 hover:text-slate-700"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      ) : (
        <input
          type="text"
          value={saisie}
          onChange={(e) => setSaisie(e.target.value)}
          onFocus={() => suggestions.length && setOuvert(true)}
          placeholder="France entière — tapez une commune, un département…"
          data-testid="observatoire-zone-input"
          className="w-full h-11 px-3 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      )}
      {ouvert && suggestions.length > 0 && !zoneType && (
        <ul className="absolute z-30 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-xl max-h-72 overflow-auto">
          {suggestions.map((s) => (
            <li key={`${s.type}-${s.cle}`}>
              <button
                type="button"
                onClick={() => { setOuvert(false); setSaisie(''); onChoisir(s); }}
                data-testid={`observatoire-zone-option-${s.type}-${s.cle}`}
                className="w-full text-left px-3 py-2.5 hover:bg-slate-50 flex items-center justify-between gap-2"
              >
                <span className="text-sm text-slate-800 truncate">{s.libelle}</span>
                <span className="text-[10px] uppercase tracking-wide text-slate-400 shrink-0">
                  {TYPES[s.type]}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ZoneAutocomplete;
